<div class="p-dialog-header">
    <span i18n>
        Доверенность
		<i *ngIf="mchd?.transitionMethod === 1" class="pi pi-exclamation-circle" pTooltip="{{ getTooltipText() }}" tooltipPosition="right"></i>
    </span>
    <app-icon (click)="close()">close</app-icon>
</div>
<section>
	<main>
        <table>
            <tbody>
                <tr *ngIf="mchd?.uuid">
                    <td i18n>Номер:</td>
                    <td>{{ mchd?.uuid }}</td>
                </tr>
                <tr *ngIf="mchd?.link">
                    <td i18n>Ссылка:</td>
                    <td>{{ mchd?.link }}</td>
                </tr>
                <tr *ngIf="mchd?.principalInn">
                    <td i18n>ИНН доверителя:</td>
                    <td>{{ mchd?.principalInn }}</td>
                </tr>
                <tr *ngIf="mchd?.agentInn">
                    <td i18n>ИНН доверенного лица:</td>
                    <td>{{ mchd?.agentInn }}</td>
                </tr>
                <tr *ngIf="mchd?.dateStart">
                    <td i18n>Дата выдачи:</td>
                    <td>{{ mchd?.dateStart | date: "dd.MM.yyyy, HH:mm" }}</td>
                </tr>
                <tr *ngIf="mchd?.dateEnd">
                    <td i18n>Дата окончания:</td>
                    <td>{{ mchd?.dateEnd | date : "dd.MM.yyyy, HH:mm" }}</td>
                </tr>
            </tbody>
        </table>
        <div class="additional" *ngIf="mchd?.parentMchd?.length">
            <button (click)="showParentMchd = !showParentMchd">
                <span i18n>Родительские доверенности</span>
                <span class="pi {{ showParentMchd ? 'pi-chevron-up' : 'pi-chevron-down' }}"></span>
            </button>
            <div class="table-container" *ngIf="showParentMchd">
                <div class="table-block" *ngFor="let mchd of mchd?.parentMchd">
                    <p i18n>Доверенность</p>
                    <table>
                        <tbody>
                            <tr *ngIf="mchd?.uuid">
                                <td i18n>Номер:</td>
                                <td>{{ mchd?.uuid }}</td>
                            </tr>
                            <tr *ngIf="mchd?.link">
                                <td i18n>Ссылка:</td>
                                <td>{{ mchd?.link }}</td>
                            </tr>
                            <tr *ngIf="mchd?.principalInn">
                                <td i18n>ИНН доверителя:</td>
                                <td>{{ mchd?.principalInn }}</td>
                            </tr>
                            <tr *ngIf="mchd?.agentInn">
                                <td i18n>ИНН доверенного лица:</td>
                                <td>{{ mchd?.agentInn }}</td>
                            </tr>
                            <tr *ngIf="mchd?.dateStart">
                                <td i18n>Дата выдачи:</td>
                                <td>{{ mchd?.dateStart | date : "dd.MM.yyyy, HH:mm" }}</td>
                            </tr>
                            <tr *ngIf="mchd?.dateEnd">
                                <td i18n>Дата окончания:</td>
                                <td>{{ mchd?.dateEnd | date : "dd.MM.yyyy, HH:mm" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
	</main>
</section>
